<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        QA | Edit Override | {{ override.keyword }}
      </h2>
      <div class="flex items-center justify-end space-x-3">
        <a v-bind:href="$route('qa.overrides.index')" class="btn btn-secondary">Cancel</a>
        <button v-on:click="form.post($route('qa.overrides.update', override.id))" v-bind:disabled="form.processing" class="btn btn-primary" type="button">Save</button>
      </div>
    </div>
  </div>

  <div class="card mb-8">
    <div class="card-body">
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
          <label for="name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Keyword </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <input v-model="form.keyword" type="text" id="name" class="rounded-md shadow-sm border-gray-300 focus:outline-none focus:border-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 disabled:opacity-25 transition ease-in-out duration-150 max-w-lg block w-full sm:max-w-xs sm:text-sm" />
            <small v-if="errors.keyword" class="text-sm text-red-500">{{ errors.keyword }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";

const { errors, override } = defineProps({
  errors: Object,
  override: Object,
});

const form = useForm({
  keyword: override.keyword
});
</script>
